import {
  BaseEntityDTO,
  EntryFieldDTO,
  IBaseEntityDTO,
  IEntryFieldDTO,
  ISubmissionEntryFormDTO,
  SubmissionEntryFormDTO,
} from './';

export interface ISubmissionEntryFormFieldDTO extends IBaseEntityDTO {
  submissionEntryForm: ISubmissionEntryFormDTO;
  entryField: IEntryFieldDTO;
  value: string;
  isValid(): boolean;
}

export class SubmissionEntryFormFieldDTO
  extends BaseEntityDTO
  implements ISubmissionEntryFormFieldDTO
{
  submissionEntryForm: ISubmissionEntryFormDTO;
  entryField: IEntryFieldDTO;
  value: string;
  constructor(data?: Partial<SubmissionEntryFormFieldDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.submissionEntryForm = new SubmissionEntryFormDTO(data?.submissionEntryForm);
    this.entryField = new EntryFieldDTO(data?.entryField);
    this.value = data?.value ?? '';
  }

  isValid = (): boolean => {
    let valid = true;
    if (this.entryField.is_required && this.value == '') {
      valid = false;
    }
    return valid;
  };
}
